import { gql } from '@apollo/client'

export const GET_GOVERNMENT_JOB_TITLES_BY_HIRING_OFFICE_ID = gql`
  query governmentJobTitlesByHiringOfficeId($hiringOfficeId: HashedId!, $excludePartnerLevels: Boolean = false) {
    governmentJobTitlesByHiringOfficeId(hiringOfficeId: $hiringOfficeId, excludePartnerLevels: $excludePartnerLevels) {
      id
      hiringOffice {
        id
        code
      }
      department
      title
      level
      monthlySalaryMinimum
      monthlySalaryMaximum
      currency
      sortOrder
    }
  }
`
